import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import * as URI from 'urijs';

import { getUplayClientEndpoint } from '@sitegen/common/utils/ubi-services';
import { PYC_REDEMPTION_ENDPOINT } from './pyc-redeem.constants';
import { ENV } from '@sitegen/common/constants/environments';

import {
    IConfigureUplayServiceAPIServiceOptions,
    ISessionHeadersOptions,
    IUplayClientProduct
} from './pyc-redeem.types';

export class PYCRedeemAPIService {
    private static AXIOS_INSTANCE: AxiosInstance;
    private static ENV: ENV;
    private static session: ISessionHeadersOptions;
    private static countryCode: string;

    /** Provide headers and other options to each request */
    public static configure(options: IConfigureUplayServiceAPIServiceOptions): void {
        const headers: object = {
            'Ubi-AppId': options.appId
        };

        this.ENV = options.env;
        this.countryCode = options.countryCode;
        this.AXIOS_INSTANCE = axios.create({ headers });
        if (options.session) {
            this.configureSession(options.session);
        }
    }

    public static configureSession(session: ISessionHeadersOptions): void {
        this.session = session;
        this.AXIOS_INSTANCE.interceptors.request.use((config: AxiosRequestConfig) => {
            if (this.session) {
                config.headers['Authorization'] = `ubi_v1 t=${this.session.ticket}`;
            }
            return config;
        });
    }

    public static async getPYCRedeemProducts(): Promise<IUplayClientProduct[]> {
        const host: string = getUplayClientEndpoint(this.ENV, this.countryCode);
        const url: string = new URI(host).segment(PYC_REDEMPTION_ENDPOINT).href();
        const response: IUplayClientProduct[] = await this.request({ url, method: 'GET' });
        return response;
    }

    private static request<T>(options: AxiosRequestConfig): Promise<T> {
        return this.AXIOS_INSTANCE.request({ ...options, responseType: 'json' })
            .then((response: AxiosResponse): T => {
                return response.data;
            }).catch((e: AxiosError): never => {
                throw e.response!.status;
            });
    }
}
